import { render, staticRenderFns } from "./CompetitionProgramForm.vue?vue&type=template&id=c55d2204&"
import script from "./CompetitionProgramForm.vue?vue&type=script&lang=js&"
export * from "./CompetitionProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports